import { render } from "./ActivityFeed.vue?vue&type=template&id=8aeef402&scoped=true"
import script from "./ActivityFeed.vue?vue&type=script&lang=js"
export * from "./ActivityFeed.vue?vue&type=script&lang=js"

import "./ActivityFeed.vue?vue&type=style&index=0&id=8aeef402&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8aeef402"]])

export default __exports__